import React, {useRef, forwardRef, useImperativeHandle} from 'react';
import './index.scss';
import ChinaPostPic from '../../../../../assets/chin-post.png';
import Form, {Item, RequiredRule, Label, ButtonItem} from 'devextreme-react/form';
import shipmentApi from '../../../../../api/shipment';
import sessions from '../../../../../sessions';

const ChinaPost = forwardRef((props, ref) => {
    const formData = useRef({});
    const userId = sessions.getSession("user")?.id;

    const onSubmit = (async(e) => {
        if (e) 
            e.preventDefault();
        
        const {shopName} = formData.current;
        if (shopName) {
            try {
                await shipmentApi.getOAuth("chinaPost", userId, shopName).then(res => {
                        window.location.href = res.data.data
                })
            } catch (err) {
                console.log(err);
            }
        }
    })

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <React.Fragment>
            <div className="bridge-header">
                <img alt="ChinaPostPic" src={ChinaPostPic} className="logo-size"/>
            </div>
            <div className="bridge-content">
                <p>Follow these steps to get connected:</p>
                <br/>
                <p>1. Type your 4PX account user name</p>
                <br/>
                <div className="bridge-content">
                    <form onSubmit={onSubmit}>
                        <Form formData={formData.current} className="form-field" labelLocation={'left'}>
                            <Item
                                dataField="shopName"
                                editorType="dxTextBox"
                                showClearButton={true}
                                editorOptions={{
                                width: 200,
                                stylingMode: 'filled',
                                placeholder: ''
                            }}>
                                <RequiredRule message="shopname is required"/>
                                <Label text={"user name"}/>
                            </Item>
                            <ButtonItem horizontalAlignment="left" //This button help to preventdefault
                                buttonOptions={{
                                text: 'shadowButton',
                                type: 'success',
                                useSubmitBehavior: true,
                                visible: false
                            }}/>
                        </Form>
                    </form>

                </div>
                <p>2. Click Connect</p>
                <br/>
            </div>
        </React.Fragment>
    );
})

export default ChinaPost;
